import { createAction, Action, handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { debug } from '../../../utils';
import { locate } from './actions';

//const DEFAULT_POSITION = { latitude: 43.0988964, longitude: -87.9046935 };
//const initialState = inBrowser ? DEFAULT_POSITION : {longitude: 0, latitude: 0};

interface LocationReducers { [actionType: string]: {(state: any, action: Action<any>): any };}
const _locationReducers: LocationReducers = {
    [locate.names.START]: (state, action) => {
        return ({ inProgress: true, data: state.data});
    },
    [locate.names.COMPLETED]: (state, action) => {
        const coords = action.payload;
        const { latitude, longitude } = coords;
        //do short and long form just because
        return {inProgress: false, data: {latitude, longitude, lat: latitude, lng: longitude}};
    },
    [locate.names.REJECTED]: (state, action) => {
        const { message, code } = action.payload;
        const error = { message, code };
        return {...state, inProgress: false, error};
    }
};

const initialState = {};
const locationReducers = handleActions<any>(_locationReducers, initialState as any);

export default {
    location: locationReducers
};



// WEBPACK FOOTER //
// ./src/app/models/Location/reducers.ts